import React from 'react';
import { Target } from 'lucide-react';

// ═══════════════════════════════════════════════════════════════════════════
// FASE A · Challenge Intro (SOLO ALUMNO) — componente PRESENTACIONAL puro.
//
// Toda la lógica de "una sola vez por entrada" (stepKey estable) y el timer de
// auto-cierre viven en el PADRE (ClassroomLive), que es estable y NO se
// re-monta con el polling. Este componente solo pinta el overlay cuando
// `visible` es true. Es 100% presentacional:
//   • NO cambia de step, NO hace requests, NO toca challengeStatus/intentos,
//     NO toca respuestas C3, NO toca el FEN ni el tablero, NO toca el polling.
//   • NO reutiliza el contador de Quiz (sin acoplamiento Classroom→Quiz).
//
// z-index: por encima del ExplanationViewer (z-50) y del pill UX-5 (z-[60]).
// ═══════════════════════════════════════════════════════════════════════════
export default function ChallengeIntro({ visible, challengeType, onDismiss }) {
  if (!visible) return null;

  const isMove = challengeType === 'move';
  const emoji = isMove ? '♟️' : '🎯';
  const detail = isMove ? 'Realiza el movimiento indicado.' : 'Encuentra la casilla indicada.';

  return (
    <div
      data-testid="challenge-intro"
      onClick={onDismiss}
      className="fixed inset-0 z-[70] grid place-items-center bg-slate-900/50 backdrop-blur-sm animate-in fade-in duration-200 cursor-pointer"
    >
      <div
        className="mx-4 max-w-[90vw] rounded-3xl bg-white shadow-2xl ring-1 ring-slate-200 px-8 py-7 text-center animate-in zoom-in-95 slide-in-from-bottom-2 duration-300"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mx-auto mb-3 grid h-14 w-14 place-items-center rounded-2xl bg-amber-100 text-amber-600">
          <Target className="h-7 w-7" />
        </div>
        <div data-testid="challenge-intro-title" className="font-display text-2xl font-black text-slate-900">
          <span className="mr-1">{emoji}</span> ¡Es tu turno de practicar!
        </div>
        <div data-testid="challenge-intro-detail" className="mt-2 text-base text-slate-600">
          {detail}
        </div>
        <button
          data-testid="challenge-intro-dismiss"
          onClick={onDismiss}
          className="mt-5 inline-flex items-center rounded-full bg-amber-500 px-5 py-2 text-sm font-bold text-white transition-colors hover:bg-amber-600"
        >
          ¡Vamos!
        </button>
      </div>
    </div>
  );
}
